import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    menuOpen: Boolean
  }

  toggleMobileMenu (event) {
    event.preventDefault()
    this.menuOpenValue = !this.menuOpenValue
    return false
  }
}
